// Holy Grail Affiliate Analytics Engine - Main App Router
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingGate from './pages/LandingGate';
import ExclusivePortal from './pages/ExclusivePortal';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Landing Gate - Route / */}
        <Route path="/" element={<LandingGate />} />
        
        {/* Exclusive Portals - Dynamic route with platform param */}
        <Route path="/:platform" element={<ExclusivePortal />} />
        
        {/* Fallback - Redirect to Landing Gate */}
        <Route path="*" element={<LandingGate />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
